import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Storefront, Home } from '@mui/icons-material';
import { ShopTab } from './customer/CustomerDashboard';
import PublicStorePage from './PublicStorePage';
import AuthPage from './AuthPage';
import { authAPI } from '../api';

export default function GuestDiscoveryPage() {
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [showAuth, setShowAuth] = useState(false);
    // undefined = still checking, null = guest, object = logged-in user
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        if (!localStorage.getItem('access_token')) { setUser(null); return; }
        authAPI.getCurrentUser()
            .then(res => setUser(res.data))
            .catch(() => setUser(null));
    }, []);

    if (showAuth) {
        return (
            <AuthPage
                onLoginSuccess={() => { window.location.href = '/?view=customer'; }}
                onBack={() => setShowAuth(false)}
            />
        );
    }

    if (selectedVendor) {
        return (
            <PublicStorePage
                businessId={selectedVendor.f_id}
                onBack={() => setSelectedVendor(null)}
            />
        );
    }

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
            <Box sx={{
                bgcolor: 'primary.main', color: 'white',
                px: 2, pb: 1.5,
                pt: 'calc(12px + env(safe-area-inset-top, 0px))',
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 1160, mx: 'auto', width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Storefront sx={{ fontSize: 20 }} />
                        <Typography variant="subtitle1" fontWeight={800}>Vendora88</Typography>
                    </Box>
                    {user ? (
                        <Button size="small" variant="contained" startIcon={<Home sx={{ fontSize: '16px !important' }} />}
                            onClick={() => { window.location.href = '/?view=customer'; }}
                            sx={{ bgcolor: 'white', color: 'primary.main', fontSize: '0.75rem', py: 0.25,
                                fontWeight: 700, maxWidth: 160, '&:hover': { bgcolor: 'grey.100' } }}>
                            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {user.f_name || 'My Dashboard'}
                            </Box>
                        </Button>
                    ) : user === null ? (
                        <Button size="small" variant="contained"
                            onClick={() => setShowAuth(true)}
                            sx={{ bgcolor: 'white', color: 'primary.main', fontSize: '0.75rem', py: 0.25,
                                fontWeight: 700, '&:hover': { bgcolor: 'grey.100' } }}>
                            Login / Sign up
                        </Button>
                    ) : null}
                </Box>
            </Box>

            <Box sx={{ p: 2, pb: 'calc(24px + env(safe-area-inset-bottom, 0px))', maxWidth: 1160, mx: 'auto' }}>
                <ShopTab
                    vendors={[]}
                    onSelectVendor={(v) => setSelectedVendor(v)}
                    apiMode="guest"
                />
            </Box>
        </Box>
    );
}
